import { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../header/GlobalContext";

export default function H2hMatchModal() {
  const { h2hWager, h2hCount, h2hOpponent } = useContext(GlobalContext);
  const [opponentData, setOpponentData] = useState(null);
  const h2hPayout = (h2hWager * 1.8).toFixed(2);

  useEffect(() => {
    const fetchOpponentData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const opponentOid = urlParams.get('h2h');
      const response = await fetch('/wp-admin/admin-ajax.php?action=fetch_athletes_from_order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          opponent_oid: opponentOid,
        }),
      });

      const result = await response.json();
      if (result.success) {
        setOpponentData(result.data);
      } else {
        console.error('Failed to fetch athletes:', result);
      }
    };

    if (h2hOpponent) {
      fetchOpponentData();
    }
  }, [h2hOpponent]);

  return (
    <div className="modal fade mt-5" id="h2h-match-modal" tabIndex={-1} role="dialog" aria-labelledby="Head to Head details" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <div class="w-100"><h2 class="modal-title">Head-to-Head</h2></div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div style={{fontSize: 40}}>👥</div>
            <h2>Head-to-Head Mode Active</h2>
            <h2>You're now playing against {h2hOpponent}.</h2>
            <h3>This is 50/50 chance to win ${h2hPayout} on a ${h2hWager} entry.</h3>
            <p>Simply select {h2hCount} athletes and place your entry.</p>

            <div>Your opponent has selected:</div>
            {opponentData && (
              <div className="row">
                {opponentData.selections.map((athlete, index) => (
                  <div key={index} className="athlete-card flex-fill m-2">
                    <img height="110" alt={athlete.name} src={athlete.image} />
                    <div>{athlete.name}</div>
                    <div>{athlete.selected} than {athlete.stat} {athlete.stat_display}</div>
                  </div>
                ))}
              </div>
            )}

            <button className="mt-3 btn btn-outline-danger w-100" data-dismiss="modal" aria-label="Close">Great, let's play!</button>
          </div>
        </div>
      </div>
    </div>
  )
}